import {
  EVENT_TYPE_AUTHORIZATION_REQUEST,
  EVENT_TYPE_END_CHARGING_SESSION,
  EVENT_TYPE_EV_CONNECTED,
  EVENT_TYPE_FINISH_APPLYING_LIMIT,
  EVENT_TYPE_START_APPLYING_LIMIT,
  EVENT_TYPE_START_CHARGING_SESSION,
  EVENT_TYPE_START_DISCHARGING_SESSION,
} from '../../LogEvents/helper';
import { makeCharger, makeEvent } from '../helper';

const defaultEventValuesByType = {
  [EVENT_TYPE_EV_CONNECTED]: {
    current_requested: 100,
    current_charging_requested: 0,
    number_of_phases: 1,
  },
  [EVENT_TYPE_START_APPLYING_LIMIT]: {
    current_limit: 75.0,
  },
  [EVENT_TYPE_FINISH_APPLYING_LIMIT]: {
    current_limit: 75.0,
  },
  [EVENT_TYPE_START_CHARGING_SESSION]: {
    session_id: '16546DS65A',
    session_type: '15118_DC',
    start_time: 1544717036,
  },
  [EVENT_TYPE_START_DISCHARGING_SESSION]: {
    session_id: '16546DS65A',
    session_type: '15118_DC',
    start_time: 1544717036,
  },
  [EVENT_TYPE_END_CHARGING_SESSION]: {
    session_id: '16546DS65A',
    session_type: '15118_DC',
    start_time: 1544717036,
    departure_time: 1544717036 + 3650,
    end_time: 1544717036 + 3600,
  },
};

const plazaUuid = 'a81be6fe-a026-467b-bc36-1be3bc9d95b0';

const CHARGERS = [
  makeCharger(plazaUuid, 'LIVA Charger'),
];

const makeValuableEvent = (chargers, eventType, values) => makeEvent(chargers, eventType, values || defaultEventValuesByType[eventType]);

const startingPosition = {
  x: 680,
  y: 25,
};

export const nodes = {
  topology: {
    children: [
      {
        children: [
          {
            children: [
              {
                children: [
                  {
                    children: [
                      {
                        children: [],
                        id: 'ID-CHARGER-1',
                      },
                    ],
                    id: 'ID-CHARGER-BREAKER',
                  },
                  {
                    children: [
                      {
                        children: [
                          {
                            children: [],
                            id: 'ID-BUILDING',
                          },
                        ],
                        id: 'ID-BUILDING-METER',
                      },
                    ],
                    id: 'ID-BUILDING-BREAKER',
                  },
                ],
                id: 'ID-JUNCTION',
              },
            ],
            id: 'ID-MAIN-BREAKER',
          },
        ],
        id: 'ID-MAIN-METER',
      },
    ],
    id: 'ID-GRID',
  },
  nodeList: [
    {
      id: 'ID-GRID',
      topologyNodeType: 'ROOT',
      staticSection: {
        positionX: startingPosition.x,
        positionY: startingPosition.y,
        maxCurrentLimit: '300',
        nodeName: 'Grid',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
        voltage: '240',
      },
    },
    {
      id: 'ID-MAIN-METER',
      topologyNodeType: 'MEASUREMENT_POINT',
      staticSection: {
        positionX: startingPosition.x,
        positionY: startingPosition.y + 145,
        nodeName: 'Main Meter',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
      },
    },
    {
      id: 'ID-MAIN-BREAKER',
      topologyNodeType: 'CONSTRAINT',
      staticSection: {
        positionX: startingPosition.x,
        positionY: startingPosition.y + 275,
        maxCurrentLimit: '300',
        nodeName: 'Main Breaker',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
      },
    },
    {
      id: 'ID-JUNCTION',
      topologyNodeType: 'JUNCTION',
      staticSection: {
        positionX: startingPosition.x,
        positionY: startingPosition.y + 385,
        nodeName: 'J1',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
      },
    },
    {
      id: 'ID-CHARGER-BREAKER',
      topologyNodeType: 'CONSTRAINT',
      staticSection: {
        positionX: startingPosition.x - 120,
        positionY: startingPosition.y + 465,
        maxCurrentLimit: '80',
        nodeName: 'Charger Breaker',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
      },
    },
    {
      id: 'ID-BUILDING-BREAKER',
      topologyNodeType: 'CONSTRAINT',
      staticSection: {
        positionX: startingPosition.x + 120,
        positionY: startingPosition.y + 465,
        maxCurrentLimit: '200',
        nodeName: 'Building Breaker',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
      },
    },
    {
      id: 'ID-CHARGER-1',
      topologyNodeType: 'CHARGER',
      staticSection: {
        positionX: startingPosition.x - 120,
        positionY: startingPosition.y + 595,
        discharging: true,
        minCurrentLimit: '8',
        condition: 'ACTIVE',
        nodeName: 'LIVA Charger',
        defaultOfflineCurrentLimit: '10',
        chargerUuid: 'IOT00120C2DF6CB4R23',
        voltage: '240',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
      },
    },
    {
      id: 'ID-BUILDING-METER',
      topologyNodeType: 'MEASUREMENT_POINT',
      staticSection: {
        positionX: startingPosition.x + 120,
        positionY: startingPosition.y + 595,
        nodeName: 'Sub Meter',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
      },
    },
    {
      id: 'ID-BUILDING',
      topologyNodeType: 'LOAD',
      staticSection: {
        positionX: startingPosition.x + 120,
        positionY: startingPosition.y + 725,
        maxCurrentLimit: '200',
        maxPower: '48000',
        nodeName: 'Building',
        phases: {
          relativeRotation: {
            1: '1',
          },
          absoluteRotation: {
            1: '1',
          },
        },
      },
    },
  ],
  externalSources: [],
  widgets: {
    time: [
      { h: 8, m: 30 },
      { h: 8, m: 31 },
      { h: 9, m: 25 },
      { h: 11, m: 10 },
      { h: 11, m: 30 },
      { h: 11, m: 45 },
      { h: 12, m: 5 },
      { h: 14, m: 0 },
      { h: 16, m: 0 },
      { h: 18, m: 4 },
      { h: 18, m: 20 },
      { h: 18, m: 35 },
    ],
    savedMoney: [
      [{ label: 'Saved YTD', value: 2252.50 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2252.50 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2252.50 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2252.50 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2252.50 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2252.50 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2252.69 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2256.98 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2261.45 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2261.45 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2261.45 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
      [{ label: 'Saved YTD', value: 2261.45 }, { label: 'Estimated Annual Savings', value: 5406.00 }],
    ],
    batteryLevel: [40.00, 40.08, 55.26, 85.26, 90.00, 90.00, 88.71, 49.23, 40.00, 40.85, 45.92, 50.05],
  },
  source: {
    'ID-CHARGER-1': {
      energyMode: ['IDLE', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'CHARGING', 'DISCHARGING', 'DISCHARGING', 'DISCHARGING', 'CHARGING', 'CHARGING', 'IDLE'],
      online: [true, true, true, true, true, true, true, true, true, true, true, true, true],
      evConnected: [true, true, true, true, true, true, true, true, true, true, true, true, true],
      authorizationRequested: [true, false, false, false, false, false, false, false, false, false, false, false],
      presentSoc: [40.00, 40.08, 55.26, 85.26, 90.00, 90.00, 88.71, 49.23, 40.00, 40.85, 45.92, 50.05],
      chargingLoadRequested: [null, 80, 80, 80, 80, 80, -80, -80, -80, 80, 80, null],
      chargingLoadLimit: [null, 80, 80, 80, 80, 80, -80, -80, -80, 80, 80, null],
      applyingLimit: [false, true, false, false, false, false, true, false, false, true, false, false],
      power: [0.0, 6400, 19000, 17900, 3000, 0.0, -19000, -18900, 0.0, 19100, 18900, 0.0],
      presentLoad: [0.0, 26.7, 79.1, 74.7, 12.5, 0.0, -79.1, -78.7, 0.0, 79.8, 78.7, 0.0],
      presentLoadPhA: [0.0, 4, 10, 10, 2.5, 0.0, -10, -10, 0.0, 10, 10, 0.0],
      presentLoadPhB: [0.0, 6, 20, 10, 2.5, 0.0, -20, -15, 0.0, 20, 15, 0.0],
      presentLoadPhC: [0.0, 16.7, 49.1, 54.7, 7.5, 0.0, -49.1, -53.7, 0.0, 49.8, 53.7, 0.0],
      presentVoltage: [null, 240, 240, 240, 240, 240, 240, 240, 240, 240, 240, null],
      presentEnergy: [0.00, 0.08, 15.26, 45.26, 50.00, 50.00, 48.71, 9.23, 0.00, 0.85, 5.92, 10.05],
      sessionType: [null, 'ISO_ED1_AC', 'ISO_ED1_AC', 'ISO_ED1_AC', 'ISO_ED1_AC', 'ISO_ED1_AC', 'ISO_ED1_AC', 'ISO_ED1_AC', 'ISO_ED1_AC', 'ISO_ED1_AC', 'ISO_ED1_AC', null],
      chargingError: [false, false, false, false, false, false, false, false, false, false, false, false, false],
      socStart: [null, 40.00, 40.00, 40.00, 40.00, 40.00, 40.00, 40.00, 40.00, 40.00, 40.00, null],
      powerLimit: [null, null, null, null, null, null, null, null, null, null, null, null, null],
      duration: [null, 1, 55, 160, 180, 195, 215, 330, 450, 574, 590, null],
      idTag: [null, '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D6', '02AB02F622D6', null],
      sessionId: [null, '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', '02AB02F622D5', null],
      energyDirection: [null, 'IN', 'IN', 'IN', 'IN', 'IN', 'OUT', 'OUT', 'OUT', 'IN', 'IN', null],
    },
    // Load 1:
    'ID-BUILDING': {
      power: [21600, 21600, 24480, 28320, 29280, 34560, 36000, 38400, 34080, 28800, 26400, 25920], // + Present Power
      presentLoad: [90.00, 90.00, 102.00, 118.00, 122.00, 144.00, 150.00, 160.00, 142.00, 120.00, 110.00, 108.00], // + Present Load
      energyDirection: ['IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN'],
    },
    // Meter S:
    'ID-BUILDING-METER': {
      power: [21600, 21600, 24480, 28320, 29280, 34560, 36000, 38400, 34080, 28800, 26400, 25920],
      presentLoad: [90.00, 90.00, 102.00, 118.00, 122.00, 144.00, 150.00, 160.00, 142.00, 120.00, 110.00, 108.00],
    },
    // Junction:
    'ID-JUNCTION': {
      energyDirection: ['IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN', 'IN'],
      energySplitGrid: [100, 100, 100, 100, 100, 100, 47, 51, 100, 100, 100, 100],
      energySplitCharger: [0, 0, 0, 0, 0, 0, 53, 49, 0, 0, 0, 0],
    },
    // Breaker charger:
    'ID-CHARGER-BREAKER': {
      presentLoad: [0.0, 26.7, 79.1, 74.7, 12.5, 0.0, -79.1, -78.7, 0.0, 79.8, 78.7, 0.0],
    },
    // Breaker main:
    'ID-MAIN-BREAKER': {
      presentLoad: [90.00, 116.67, 181.07, 192.75, 134.46, 144.00, 70.86, 81.26, 142.00, 199.76, 188.65, 108.00],
    },
    'ID-MAIN-METER': {
      presentLoad: [90.00, 116.67, 181.07, 192.75, 134.46, 144.00, 70.86, 81.26, 142.00, 199.76, 188.65, 108.00],
    },
    'ID-BUILDING-BREAKER': {
      presentLoad: [90.00, 90.00, 102.00, 118.00, 122.00, 144.00, 150.00, 160.00, 142.00, 120.00, 110.00, 108.00],
    },
    // Grid:
    'ID-GRID': {
      presentLoad: [90.00, 116.67, 181.07, 192.75, 134.46, 144.00, 63.98, 74.41, 142.00, 199.76, 188.65, 108.00],
    },
  },
  events: [
    // 1
    [
    ],
    // 2
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_AUTHORIZATION_REQUEST),
    ],
    // 3
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_START_CHARGING_SESSION),
    ],
    // 4
    [

    ],
    // 5
    [

    ],
    // 6
    [

    ],
    // 7
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_END_CHARGING_SESSION),
    ],
    // 8
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_START_DISCHARGING_SESSION),
    ],
    // 9
    [

    ],
    // 10
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_END_CHARGING_SESSION),
    ],
    // 11
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_START_CHARGING_SESSION),
    ],
    // 12
    [
      makeValuableEvent(CHARGERS[0], EVENT_TYPE_END_CHARGING_SESSION),
    ],
  ],
};
